import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { ListItemBlockAttsInterface } from '~/types/AppData/Blocks/ListItemBlockInterface';
import { getKeyFromBlock } from '~/utilities/getKeyFromBlock';
import ContentBlock from '~/components/Layout/Builders/ContentBlock';
import type { TitleBlockAttsInterface } from '~/types/AppData/Blocks/TitleBlockInterface';
import { useBlockClasses } from '~/utilities/useBlockClasses';

export default component$((value: ListItemBlockAttsInterface): JSX.Element => {
  const blockClasses = useBlockClasses();

  return value.items.map((each, index) => {
    if (each.type === 'title') {
      const title = each.value as TitleBlockAttsInterface;

      return (
        <h2
          key={title.listItemNumber}
          id={`list-item-${value.index}`}
          class={blockClasses}
        >
          <span class='text-primary inline-block mr-2'>
            {`${title.listItemNumber}. `}
          </span>
          <span class='text-darkGrey'>{title.text}</span>
        </h2>
      );
    }

    return (
      <ContentBlock
        key={getKeyFromBlock(each, index)}
        item={each}
        index={index}
      />
    );
  });
});
